import React, { useId } from "react";

/**
 * HoneyAcorn brand mark — the official acorn-in-cell logo.
 * Geometry matches /public/honeyacorn-mark.svg and the brand kit exactly.
 *
 *   default        two-tone: honey-gradient cell + cream acorn
 *   color="#14161A" mono ink (acorn knocked out via even-odd)
 *   color="#F7E7C8" reversed/cream, for dark surfaces
 */
const CELL =
  "M42.15 19.93 Q44.50 24.00 42.15 28.07 L36.60 37.68 Q34.25 41.75 29.55 41.75 L18.45 41.75 Q13.75 41.75 11.40 37.68 L5.85 28.07 Q3.50 24.00 5.85 19.93 L11.40 10.32 Q13.75 6.25 18.45 6.25 L29.55 6.25 Q34.25 6.25 36.60 10.32 Z";
const CAP =
  "M16.7 19.8 C16.7 17 19.9 14.9 24 14.9 C28.1 14.9 31.3 17 31.3 19.8 L16.7 19.8 Z";
const NUT =
  "M18.2 21.2 L29.8 21.2 L29.8 26.3 C29.8 30.2 27.2 33 24 33 C20.9 33 18.2 30.2 18.2 26.3 L18.2 21.2 Z";
// Full acorn silhouette — used as the even-odd knockout in mono variants.
const ACORN =
  "M16.7 19.8 C16.7 17 19.9 14.9 24 14.9 C28.1 14.9 31.3 17 31.3 19.8 C31.3 20.5 30.8 21 29.8 21.1 L29.8 26.3 C29.8 30.2 27.2 33 24 33 C20.9 33 18.2 30.2 18.2 26.3 L18.2 21.1 C17.3 21 16.7 20.5 16.7 19.8 Z";

export default function HoneyAcornMark({
  size = 34,
  color,
  cap = "#EBD9B2",
  nut = "#FCF6EA",
  ...p
}) {
  const gid = useId();
  const mono = Boolean(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label="HoneyAcorn"
      {...p}
    >
      {!mono && (
        <defs>
          <linearGradient id={gid} x1="0.12" y1="0" x2="0.9" y2="1">
            <stop offset="0" stopColor="#EFBA57" />
            <stop offset="0.55" stopColor="#C6851E" />
            <stop offset="1" stopColor="#8E560E" />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        fill={mono ? color : `url(#${gid})`}
        d={mono ? `${CELL} ${ACORN}` : CELL}
      />
      {!mono && (
        <>
          <path fill={cap} d={CAP} />
          <path fill={nut} d={NUT} />
        </>
      )}
    </svg>
  );
}
